import React, { createContext, useCallback, useContext, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

const NavigationTransitionContext = createContext(null)

export const NavigationTransitionProvider = ({ children }) => {

  const [transition, setTransition] = useState(null)

  const startTransition = useCallback(({ title, type = 'page', action }) => {
    setTransition({ title, type })

    // Give the overlay time to cover the current page
    setTimeout(() => {
      action?.()

      // Let the new page start rendering underneath
      setTimeout(() => {
        setTransition(null)
      }, 250)
    }, 200)
  }, [])

  return (
    <NavigationTransitionContext.Provider value={{ startTransition }}>
      {children}

      <AnimatePresence>
        {transition && (
          <motion.div
            key="navigation-transition"
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '-100%' }}
            transition={{
              duration: 0.25,
              ease: 'easeInOut'
            }}
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#111'
            }}
          >
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2 }}
            >
              <div
                style={{
                  fontSize: 12,
                  textAlign: 'center',
                  opacity: 0.6,
                  textTransform: 'uppercase'
                }}
              >
                {transition.type}
              </div>

              <div
                style={{
                  fontSize: 28,
                  fontWeight: 700
                }}
              >
                {transition.title}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </NavigationTransitionContext.Provider>
  )
}

export const useNavigationTransition = () => {

  const context = useContext(NavigationTransitionContext)

  if (!context) {
    throw new Error(
      'useNavigationTransition must be used inside NavigationTransitionProvider'
    )
  }

  return context
}